import { Box, Stack, Text, UnstyledButton } from '@mantine/core';
import { IconLock } from '@tabler/icons-react';
import { formatCents } from '../products/productDisplay';

// Locked teaser card appended after the public gallery grid (contract §4.1
// `private_count`). The blurred backdrop is pure CSS on a placeholder box,
// never a real image.
//
// Two variants:
// - Count-only (default): non-clickable, just "{count} more in the private
//   gallery".
// - Subscribe CTA (contract §4.19): when the seller has fan subscriptions
//   enabled, pass `priceCents` + `onSubscribe` and the teaser becomes the
//   subscribe call-to-action. Callers hide the teaser entirely for viewers
//   with an active fan subscription (their gallery already includes the
//   private items).
const teaserStyle = {
  borderRadius: 10,
  overflow: 'hidden',
  height: 150,
  background: '#111',
  position: 'relative',
  width: '100%',
};

const Backdrop = () => (
  <div
    aria-hidden
    style={{
      position: 'absolute',
      inset: 0,
      background: 'linear-gradient(135deg, rgba(233,45,134,0.45) 0%, rgba(159,56,204,0.45) 100%)',
      filter: 'blur(16px)',
      transform: 'scale(1.3)',
    }}
  />
);

const PrivateGalleryTeaser = ({ count, priceCents, onSubscribe }) => {
  if (!count || count <= 0) return null;

  if (priceCents != null && onSubscribe) {
    return (
      <UnstyledButton
        data-testid="private-gallery-teaser"
        onClick={onSubscribe}
        style={teaserStyle}
      >
        <Backdrop />
        <Stack align="center" justify="center" gap={6} px="xs" style={{ position: 'absolute', inset: 0 }}>
          <IconLock size="1.6rem" color="white" />
          <Text size="xs" fw={600} c="white" ta="center">
            Unlock {count} private item{count === 1 ? '' : 's'} — {formatCents(priceCents)}/mo
          </Text>
        </Stack>
      </UnstyledButton>
    );
  }

  return (
    <Box data-testid="private-gallery-teaser" style={teaserStyle}>
      <Backdrop />
      <Stack align="center" justify="center" gap={6} px="xs" style={{ position: 'absolute', inset: 0 }}>
        <IconLock size="1.6rem" color="white" />
        <Text size="xs" fw={600} c="white" ta="center">
          {count} more in the private gallery
        </Text>
      </Stack>
    </Box>
  );
};

export default PrivateGalleryTeaser;
